import { ListRowCategory } from './ListRowCategory';
import { ListRowMenuItem, getRowMenuItemHeight } from './ListRowMenuItem';
import { VirtualizedListConfig, VirtualizedListRowType } from '../types';

export const virtualizedListConfig: VirtualizedListConfig = {
  [VirtualizedListRowType.MENU_ITEM]: {
    component: ListRowMenuItem,
    getRowHeight: getRowMenuItemHeight,
  },
  [VirtualizedListRowType.CATEGORY]: {
    component: ListRowCategory,
    getRowHeight: () => 36,
  },
};
